import { BaseModel } from '../lib';


export default class PublishedShowtimesModel extends BaseModel {

  publishInfo = {};
  officeInfo = {};
  theaterInfos = [];
  showtimes = [];
  comingSoonInfos = [];
  newsItems = [];
  movieInfos = [];

}
